<template>
  <div>
    <c-tab
      type="horizon"
      :dense="true"
      :tabItems.sync="tabItems"
      :inlineLabel="true"
      v-model="tab"
    >
      <template v-slot:default="tab">
        <component
          :is="tab.component"
          :popupParam="popupParam"
          :fireFighting="fireFighting"
          :isOld="isOld"
          :contentHeight.sync="contentHeight"
          @getDetail="getDetail"
          @closePopup="closePopup"
        />
      </template>
    </c-tab>
  </div>
</template>
<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'fireFightingMasterDetail',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        sopFireFightingId: '',
      }),
    },
    contentHeight: null,
  },
  data() {
    return {
      tab: 'info',
      fireFighting: {
        sopFireFightingId: '',  // 소방설비 일련번호
        plantCd: null,  // 사업장
        plantName: null,  // 사업장
        sopFireFightingTypeCd: null,  // 유형
        sopFireFightingTypeName: null,  // 유형
        manageNo: '',  // 설치번호
        fireFightingName: '',  // 소방설비명
        managerId: '',  // 담당자
        deptCd: '',  // 관리부서
        amount: '',  // 수량
        chmDangerMstId: '',  // 관련 위험물 저장소 일련번호
        remarks: '', // 비고(특이사항)
        installDate: '',  // 제조년월
        disposeFlag: 'N',  // 폐기여부
        disposeDate: '',  // 폐기일
        locationName: '',
        deleteFlag: '',  // 삭제여부
        regUserId: '',  // 등록자 ID
        chgUserId: '',  // 수정자 ID
        histroy: [],
        checks: [],
        issueChecks: [],
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
    isOld() {
      return Boolean(this.popupParam.sopFireFightingId)
    },
    // tabHeight() {
    //   let height = this.contentHeight - 36;
    //   if (height < 800) {
    //     height = 800;
    //   }
    //   return String(height);
    // },
    tabItems() {
      let _items = [
        { name: 'info', icon: 'info', label: '기본정보', component: () => import(`${'./fireFightingInfo.vue'}`) },
      ]
      if (this.isOld) {
        _items.push({
          name: 'history', icon: 'construction', label: '이력', component: () => import(`${'./fireFightingHistory.vue'}`)
        })
        _items.push({
          name: 'map', icon: 'room', label: '위치', component: () => import(`${'./fireFightingUnitMap.vue'}`)
        })
      }
      return _items;
    }
  },
  watch: {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.detailUrl = selectConfig.fft.fireFighting.get.url
      // code setting
      // list setting
      this.getDetail();
    },
    getDetail() {
      if (this.isOld) {
        this.$http.url = this.$format(this.detailUrl, this.popupParam.sopFireFightingId);
        this.$http.type = 'GET';
        this.$http.request((_result) => {
          this.$_.extend(this.fireFighting, _result.data)
        },);
      } else {
        // nothing
        this.$set(this.fireFighting, 'amount', 1)
      }
    },
    closePopup() {
      this.$emit('closePopup')
    }
  }
};
</script>